import { useIntl } from 'react-intl'

import PromotionLabel from 'LuxKit/Label/PromotionLabel'

function AgentExclusivePackageLabel() {
  const intl = useIntl()

  return (
    <PromotionLabel variant="default">
      {intl.formatMessage({
        id: '4Np3x1K3ULje-ysswXzJ',
        defaultMessage: 'Agent Exclusive Package',
        description: 'Promotion label text for packages that are exclusive to Agent Hub users',
      })}
    </PromotionLabel>
  )
}

export default AgentExclusivePackageLabel
